import { NgModule } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { SsrCookieService } from '../services/ssr-cookie.service';
import { CookieModule, CookieService } from 'ngx-cookie';

// const MODULES = [];
const IMPORT_ONLY_MODULES = [
  CookieModule.withOptions({
    path: '/'
  })
];

const PROVIDERS = [CookieService, SsrCookieService, StorageService];

@NgModule({
  imports: [...IMPORT_ONLY_MODULES],
  providers: PROVIDERS,
  exports: []
})
export class StorageModule {}
